/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MagnetList } from '../../models/magnet-list';

export interface VaultGetMagnetList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetMagnetList(http: HttpClient, rootUrl: string, params: VaultGetMagnetList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetMagnetList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MagnetList>;
    })
  );
}

vaultGetMagnetList.PATH = '/vault/{vaultId}/magnet/list';
